<!--
    描述：系统管理模块入口页面
    时间：2020-04-20
    Created by ws
-->
<template>
	<transition name="fade"
				mode="out-in">
		<router-view></router-view>
	</transition>
</template>

<script>
export default {
	name: 'System-management'
}
</script>

